var imagescopeLauncher =
webpackJsonp_name_([11],{

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(552);

__webpack_require__(419);

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ImagescopeLauncher = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(2);

var _createClass3 = _interopRequireDefault(_createClass2);

var _toolbarButtonFactory = __webpack_require__(79);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BUTTON_CLASS = 'uscope-imagescope-launcher-button';
var BUTTON_HOVER_TEXT = 'Open this image in ImageScope.';

var ImagescopeLauncher = exports.ImagescopeLauncher = function () {
    function ImagescopeLauncher(uScope, downloader) {
        (0, _classCallCheck3.default)(this, ImagescopeLauncher);

        this._uScope = uScope;
        this._downloader = downloader;

        var button = (0, _toolbarButtonFactory.createToolbarButton)({
            context: this,

            className: BUTTON_CLASS,

            title: BUTTON_HOVER_TEXT,

            onClick: this.launchImagescope
        });

        uScope.topToolbar.addButton(button);
    }

    (0, _createClass3.default)(ImagescopeLauncher, [{
        key: 'configure',
        value: function configure(settings) {
            this._settings = settings;
        }
    }, {
        key: 'launchImagescope',
        value: function launchImagescope() {
            var viewport = this._uScope.getThisImage();
            var imageId = viewport.getImageId();

            if (imageId) {
                this._downloader.download({
                    uri: this._settings.targetUrlTemplate.replace('{IMAGE_IDS}', imageId.slice(1)),
                    filename: this._settings.filename
                });
            } else {
                this._uScope.notifications.warning('There is no image to open in ImageScope.');
            }

            return false;
        }
    }]);
    return ImagescopeLauncher;
}();

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loader = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(21);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(20);

var _inherits3 = _interopRequireDefault(_inherits2);

var _lbsPiDash = __webpack_require__(5);

var _helpers = __webpack_require__(4);

var _ImagescopeLauncher2 = __webpack_require__(418);

var _publicApi = __webpack_require__(6);

var _publicApi2 = _interopRequireDefault(_publicApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loader = exports.loader = {
    name: 'us:imagescope-launcher',

    extends: 'uScope',

    canStart: function canStart(uScope) {
        var settings = (0, _lbsPiDash.get)(uScope, 'vilSettings.extensions.us:imagescope-launcher');
        if (!settings) {
            // ('Cannot add ImageScope toolbar button because it hasn\'t been configured.'); // eslint-disable-line no-undef
            return false;
        }
        return uScope.toolbarCanAddButton('openImageScopeBtn');
    },


    constructor: function (_ImagescopeLauncher) {
        (0, _inherits3.default)(ImagescopeLauncherContainer, _ImagescopeLauncher);

        function ImagescopeLauncherContainer(uScope) {
            (0, _classCallCheck3.default)(this, ImagescopeLauncherContainer);

            // Inject a downloader; it's simpler to test this way...
            return (0, _possibleConstructorReturn3.default)(this, (ImagescopeLauncherContainer.__proto__ || Object.getPrototypeOf(ImagescopeLauncherContainer)).call(this, uScope, { download: _helpers.download }));
        }

        return ImagescopeLauncherContainer;
    }(_ImagescopeLauncher2.ImagescopeLauncher)
};

_publicApi2.default.plugins.register(loader);

/***/ }),

/***/ 552:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(335);


/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * As the name suggests, creates a <button> object that can be added to uScope's toolbar.
 * When styling using this method, you should set the background image manually using CSS.
 * NOTE The styling should include ".us_rootstyle" to ensure eSM rules don't override
 *      styling on hover.
 * @param className (string) - name of class to attach to button. Useful for attaching images
 * @param title (string) - alt-text that will appear when user hovers over the icon
 * @param onClick (function) - callback to execute when the user clicks the button
 */
var createToolbarButton = exports.createToolbarButton = function createToolbarButton(_ref) {
    var className = _ref.className,
        title = _ref.title,
        onClick = _ref.onClick,
        _ref$context = _ref.context,
        context = _ref$context === undefined ? null : _ref$context;

    var button = document.createElement('button');
    button.className = 'uscope-toolbar-button ' + className;
    button.title = title;

    button.addEventListener('click', function (e) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
        }

        onClick.apply(context, [e].concat(args));
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
    });

    return button;
};

/***/ })

},[619]);